import { FormItem } from "./FormItem";

export class Dropdown extends FormItem {

    public getType(): string {
        return "Dropdown";
    }

    public getValue(): string {
        const sel = this.findSelectElement();
        return sel ? sel.value : "";
    }

    protected createSelf(): void {
        const raw = this.get("choices");
        const choices = this.parseChoices(raw);
        const placeholderText = this.get("ph") || this.translate(this.get("label")) || "";
        const selected = this.trans("value");

        const optionTags: any[] = [];
        if (placeholderText && !selected) {
            optionTags.push({
                t: "t",
                _tn: "option",
                attributes: [{n: "value", v: ""}, {n: "disabled", v: ""}, {n: "selected", v: ""}],
                txt: placeholderText,
            });
        }
        for (const c of choices) {
            const value = String(c.k ?? c.v ?? c);
            const label = String(c.v ?? c.k ?? c);
            const attrs: any[] = [{n: "value", v: value}];
            if (selected !== undefined && selected !== null && String(selected) === value) {
                attrs.push({n: "selected", v: ""});
            }
            optionTags.push({t: "t", _tn: "option", attributes: attrs, txt: label});
        }

        const iclass = this.get("iclass");
        const selectAttrs: any[] = [
            {n: "ft", v: "dropdown"},
            {n: "name", v: this.get("name")},
        ];
        if (this.get("readonly")) {
            selectAttrs.push({n: "disabled", v: ""});
        }

        const sel = this.createItemTag({
            t: "t",
            _tn: "select",
            attributes: selectAttrs,
            class: iclass ? "dropdownbox " + iclass : "dropdownbox",
            c: optionTags,
        });

        this.setElement(sel.getElement());
    }

    private parseChoices(raw: any): any[] {
        if (raw === null || raw === undefined || raw === "" || raw === "undefined") {
            return [];
        }
        if (Array.isArray(raw)) {
            return raw;
        }
        if (typeof raw === "string") {
            try {
                const parsed = JSON.parse(raw);
                return Array.isArray(parsed) ? parsed : [];
            } catch {
                return [];
            }
        }
        return [];
    }

    private findSelectElement(): HTMLSelectElement | null {
        const el = this.getElement();
        if (!el) { return null; }
        if (el.tagName === "SELECT") {
            return el as HTMLSelectElement;
        }
        const inner = el.querySelector("select");
        return inner ? inner as HTMLSelectElement : null;
    }
}
